import { datadogRum } from '@datadog/browser-rum';

export const loadPageTracing = (appName, userInfo = null) => {
  const host = document.location.hostname;
  const prod = 'dv.indiansfrontoffice.com';
  const staging = 'bbstaging.indiansfrontoffice.com';
  const beta = 'beta.indiansfrontoffice.com';

  const env = host === prod ? 'prod' : host === staging ? 'staging' : host === beta ? 'dev' : 'local';
  const userId = localStorage.getItem('dv-user-guid');

  datadogRum.init({
    applicationId: 'e139f512-226d-4afd-a5a7-11c407faf294',
    clientToken: 'pubccdd8f3f44a9e7fd774d32aa77cdb7dc',
    site: 'us5.datadoghq.com',
    service: 'dvwebold',
    env,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackLongTasks: true,
    trackFrustrations: true,
    trackUserInteractions: true,
    trackViewsManually: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  if (appName) {
    datadogRum.startView({ name: appName });
  }
  
  // Set user information for Datadog tracking
  setDatadogUser(userId, userInfo);
  
  datadogRum.startSessionReplayRecording();
};

// Helper function to set Datadog user information
export const setDatadogUser = (userId, userInfo = null) => {
  if (userId) {
    const userData = { id: userId };
    
    // If we have user info from AppConstants, add the name
    if (userInfo) {
      if (userInfo.UserName) {
        userData.name = userInfo.UserName;
      }
      
      // Add scout name if available and different from UserName
      if (userInfo.ScoutName && userInfo.ScoutName !== userInfo.UserName) {
        userData.scoutName = userInfo.ScoutName;
      }
      
      // Add proxy information if available
      if (userInfo.ImAProxyLogin) {
        userData.proxiedAs = true;
      }
    }
    
    datadogRum.setUser(userData);
  }
};

export default loadPageTracing;
